<template>
    <div>
        <div class="flex flex-col mb-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    #
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Name') }}
                                </th>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Email Address') }}
                                </th>
                                <th scope="col" class="relative px-6 py-3">
                                    &nbsp;
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <template v-if="customer.users && customer.users.length > 0">
                                <UserLine
                                    :detach-endpoint="route('customer-users.detach',{'customer':customer.id,'user':user.id})"
                                    :user="user" v-for="user in customer.users"
                                    :can-delete="customer.users.length > 1"></UserLine>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="4" class="px-6 py-4 whitespace-nowrap text-center">
                                        {{ $t('No data available.') }}
                                    </td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <UserAttachForm :available-users="availableUsers"
                              @attached="userAttached"
                              :attach-endpoint="route('customer-users.attach',{'customer':customer.id})"></UserAttachForm>
        <UserCreationModal :is-active="creationMode" @closed="resetCreationMode" :workspace-id="customer.id"></UserCreationModal>
        <div class="flex py-4 justify-end">
            <JetButton
                @click.prevent="activateCreationMode()">
                {{ $t('Create new user') }}
            </JetButton>
        </div>
    </div>
</template>

<script setup>
import UserAttachForm from "./UserAttachForm.vue";
import UserCreationModal from "./UserCreationModal.vue";
import JetButton from '@/Jetstream/Button.vue'
</script>

<script>

import {Link} from "@inertiajs/vue3";
import UserLine from '@/Components/UserManagerUserLine.vue'

export default {
    name: "ConsultantManager",
    components: {
        Link,
        UserLine,
    },
    props: {
        customer: Object,
        availableUsers: Object,
    },
    computed: {},
    data() {
        return {
            creationMode: false,
        };
    },
    methods: {
        userAttached(){
            this.$inertia.reload(['customer']);
        },

        activateCreationMode() {
            this.creationMode = true;
        },

        resetCreationMode() {
            this.creationMode = false;
        },
    },
}
</script>

<style scoped>

</style>
